module.exports = __webpack_public_path__ + "media/images/countrysquared/td-47540761ab21cd9f4bb57b8f1984ba07.svg";